import React from "react"
import { Parallax } from "react-scroll-parallax"
import { graphql } from "gatsby"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"

import Seo from "../../components/seo"
import Layout from "../../components/layout"
import Nav from "../../components/nav"

import indyHeart from "../../images/indy-heart.png"
import indyThinking from "../../images/indy-thinking.svg"
import iosChatbot from "../../images/iosChatbot4.png"

const indy = (props) => {
  const faqData = props.data.allContentfulWebsiteFaq.edges
  return (
    <Layout>
      <Seo
        title="Meet Indy - Chat with Indy your very own financial buddy."
        desc="Got questions about Sparkle? Indy has got your back. Chat with
        Indy your very own financial buddy on the Sparkle App."
        isFaq
        faqData={faqData}
      />

      <div className="indy__hero">
        <div className="nav-wrapper bg__sparkle--black">
          <div className="container">
            <Nav />
          </div>
        </div>

        <div className="container">
          <div className="row align-center pt-3">
            <div className="col-lg-6">
              <h1 className="mt-5 pt-lg-5 pt-4 hero__title sparkle--font__56">
                Meet Indy
              </h1>
              <div className="description--wrapper">
                <p className="mt-4 hero__description">
                  Got questions about Sparkle? Indy has got your back. Chat with
                  Indy your very own financial buddy on the Sparkle App.
                </p>
              </div>
            </div>
            <div className="col-lg-6 mt-4 order-first order-lg-last">
              <img
                loading="lazy"
                src={indyHeart}
                className="img-fluid banner--tribe-image position-relative"
                alt="Chat with Indy your very own financial buddy on the Sparkle App."
                title="Chat with Indy your very own financial buddy on the Sparkle App."
              />
            </div>
          </div>
        </div>
      </div>

      <div className="position-relative pt-5">
        <div className="container">
          <div className="row align-center py-5">
            <div className="col-lg-5 my-3">
              <div className="description--wrapper">
                <h4 className="sparkle--title sparkle-deep-blue mb-4">
                  Who is Indy, your financial buddy?
                </h4>
              </div>
              <p className="sparkle--paragraph">
                Indy is our very own AI lifestyle and financial chatbot that
                serves as your personal assistant on everything Sparkle. Indy
                provides financial and lifestyle advise personalized for each
                Sparkler in the tribe. Indy is for EVERYONE and caters to each
                users' needs.
              </p>

              <p className="sparkle--paragraph">
                Indy is every Sparkler’s first point of contact and currently
                provides information about Sparkle and its services, guidance on
                how to use the Sparkle App, features available, regulatory
                information, conversations, and jokes to users within the
                Sparkle Tribe. A virtual assistant that helps customers
                transactions, make recommendations and answers questions.
              </p>

              <p className="sparkle--paragraph">
                Chat with Indy today. She is witty, relatable and true to all
                Sparkle values.
              </p>
            </div>

            <div className="col-lg-6 offset-lg-1 position-relative my-3 order-lg-last order-first text-center">
              <Parallax y={[30, -1]}>
                <img
                  src={indyThinking}
                  className="img-fluid position-relative"
                  alt="Who is Indy?"
                  title="Who is Indy?"
                  data-aos="reveal-image"
                  data-aos-duration="3000"
                />
              </Parallax>
            </div>
          </div>

          <div className="row align-center py-5">
            <div className="col-lg-5 position-relative my-3 text-center">
              <Parallax y={[30, -5]}>
                <img
                  src={iosChatbot}
                  className="img-fluid position-relative"
                  alt="Conversational, artificial intelligent finance help desk."
                  title="Conversational, artificial intelligent finance help desk."
                  data-aos="reveal-image"
                  data-aos-duration="3000"
                />
              </Parallax>
            </div>

            <div className="col-lg-5 my-3 offset-lg-2">
              <h4 className="sparkle--title sparkle-deep-blue mb-4">
                Conversational, artificial intelligent finance help desk.
              </h4>

              <p className="sparkle--paragraph">
                Indy as your virtual assistant helps with your general queries
                on transactions, smart financial recommendations, and answers
                your basic questions.
              </p>

              <p className="sparkle--paragraph">
                Staying true to Sparkle's values, Indy is personalized for each
                Sparkler. What does this mean? Indy reacts and responds to
                everyone differently, to make sure your experience and solutions
                are tailored and suited to your peculiar need.
              </p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row align-center py-lg-5 justify-content-center">
            <div className="col-lg-5 my-3">
              <h4 className="sparkle--title sparkle-deep-blue text-center">
                Frequently Asked Questions about Sparkle
              </h4>
            </div>
          </div>

          <div className="row py-lg-5 justify-content-center">
            <div className="col-lg-10">
              <div className="text-left">
                <Accordion allowZeroExpanded>
                  {faqData.map((faq) => (
                    <AccordionItem key={faq.node.id}>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          {faq.node.question}
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: `${faq.node.answer.childMarkdownRemark.html}`,
                          }}
                        ></div>
                      </AccordionItemPanel>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default indy

export const pageQuery = graphql`query FaqListQuery {
  allContentfulWebsiteFaq(
    sort: {createdAt: ASC}
    filter: {node_locale: {eq: "en-US"}}
  ) {
    edges {
      node {
        id
        question
        answer {
          childMarkdownRemark {
            html
          }
          answer
        }
      }
    }
  }
}`
